import './froala_theme_pulsar.less';

import React from 'react';
import FroalaEditor from 'zoomforth_component_lib/froala_editor.jsx';

import { getLinkStyleOptions } from 'zoomforth_component_lib/froala_editor.jsx';


const MCE_TAG_COMPATIBILITY_CLASSNAME = 'mce-compatibility-empty-tag';


const DefaultCodesbaneFroalaEditor = ({ config, ...props })=> {

  return (
    <FroalaEditor 
      config={{
        theme: 'pulsar', // This works with the imported theme with the `.pulsar-theme` class name. 
        typingTimer: 250,
        placeholderText: '',
        tabSpaces: 4,
        paragraphFormatSelection: true,
        linkList: [], // Make sure we dont offer any predefined links for choosing
        linkStyles: getLinkStyleOptions(),
        linkMultipleStyles: false,
        paragraphFormat: {
          N: 'P',
          H1: 'H1',
          H2: 'H2',
          H3: 'H3',
          H4: 'H4',
          H5: 'H5',
          H6: 'H6'
        },
        ...config
      }}
      {...props} 
    />
  );
};



export const ensureModelHasMceCompatibilityClassNames = (model)=> {
  const $html = $('<div>').append(model);
  if ($html.find(`.${MCE_TAG_COMPATIBILITY_CLASSNAME}`).length > 0) {
    // There are already compatibility tags present
    return model;
  }

  const $emptyTags = $html.find('p,h1,h2,h3,h4,h5,h6').filter(function(){
    // important! we use the native trim function instead of the jquery one
    // because the jquery one strips newlines and non-breaking spaces.
    return $(this).html().trim().length == 0;
  });

  if ($emptyTags.length === 0) {
    return model;
  }

  // See: viewer/style/mce_to_froala_hacks.less to see styling nature of tag
  $emptyTags.addClass(MCE_TAG_COMPATIBILITY_CLASSNAME); 
  return $html.html();
};


const MceCompatibleFroalaEditor = ({ model, ...props })=> (
  <DefaultCodesbaneFroalaEditor
    model={ensureModelHasMceCompatibilityClassNames(model)}
    {...props}
  />
);


export default MceCompatibleFroalaEditor;
